import { createReducer, on } from '@ngrx/store';

import moment from 'moment';

import { PowerLimitationHistoryActions } from './power-limitation-history.actions';
import { PowerLimitationHistoryState } from './power-limitation-history.state';
import {
  FilterType,
  PowerLimitationControlCommandType,
  PowerLimitationTableList,
} from './power-limitation-history.model';

export const initPowerLimitationHistoryState: PowerLimitationHistoryState = {
  powerLimitationData: [],
  selectedFilterData: [],
  powerLimitationControlCommandType: PowerLimitationControlCommandType.All,
  filterDateAndType: {
    type: FilterType.Month,
    date: moment(new Date()),
  },
  loading: false,
  error: null,
};

export const powerLimitationHistoryReducer = createReducer(
  initPowerLimitationHistoryState,

  on(
    PowerLimitationHistoryActions.getPowerLimitationData.attempt,
    (state): PowerLimitationHistoryState => ({
      ...state,
      loading: true,
      powerLimitationData: [],
      selectedFilterData: [],
      error: null,
    })
  ),

  on(
    PowerLimitationHistoryActions.getPowerLimitationData.success,
    (state, { powerLimitationData }): PowerLimitationHistoryState => ({
      ...state,
      powerLimitationData,
      selectedFilterData: powerLimitationData,
      loading: false,
      error: null,
    })
  ),

  on(
    PowerLimitationHistoryActions.getPowerLimitationData.error,
    (state, { error }): PowerLimitationHistoryState => ({
      ...state,
      loading: false,
      error,
    })
  ),

  on(
    PowerLimitationHistoryActions.updateFiltersByPowerLimitationType.attempt,
    (state, { powerLimitationControlCommandType }): PowerLimitationHistoryState => {
      const updatedData: PowerLimitationTableList[] =
        powerLimitationControlCommandType !== PowerLimitationControlCommandType.All
          ? state.powerLimitationData.filter(
              (item) => item.controlCommand === powerLimitationControlCommandType
            )
          : state.powerLimitationData;

      return {
        ...state,
        powerLimitationControlCommandType,
        selectedFilterData: updatedData,
      };
    }
  ),

  on(
    PowerLimitationHistoryActions.updateFiltersByDate.attempt,
    (state, { filterDateAndType }): PowerLimitationHistoryState => {
      return {
        ...state,
        powerLimitationControlCommandType: PowerLimitationControlCommandType.All,
        filterDateAndType,
      };
    }
  ),

  on(
    PowerLimitationHistoryActions.clearState.attempt,
    (): PowerLimitationHistoryState => ({
      ...initPowerLimitationHistoryState,
    })
  )
);
